module.exports = __webpack_public_path__ + "static/media/slate-bench.9e4139ef.png";